import { render } from "./DeleteModal.vue?vue&type=template&id=ac7b811c&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"

import "./DeleteModal.vue?vue&type=style&index=0&id=ac7b811c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7b811c"]])

export default __exports__